import { PureComponent } from 'react';
import Button from 'react-bootstrap/lib/Button';
import PropTypes from 'prop-types';
import cns from 'classnames';
import mapProps from 'map-props';

import { getFavoritesUrl } from 'helpers/namedUrls';
import Link from 'components/Link';
import FunnelIcon from 'components/icons/FunnelIcon.com.svg';
import FavoriteIcon from 'components/FavoriteIcon';

import SortField from './SortField';
import cn from './styles.local.less';
import propsMapping from './propsMapping';

class TopOptions extends PureComponent {
  static propTypes = {
    hasActiveFilters: PropTypes.bool.isRequired,
    hasFavorites: PropTypes.bool.isRequired,
    favoritesTotalCount: PropTypes.number.isRequired,
    onSortChanged: PropTypes.func.isRequired,
    onShowModalClick: PropTypes.func.isRequired,
    sortOptions: PropTypes.array.isRequired,
  };

  render() {
    const {
      hasFavorites,
      hasActiveFilters,
      favoritesTotalCount,
      onSortChanged,
      sortOptions,
      onShowModalClick,
    } = this.props;

    return (
      <div className={cn.root} data-qa-selector="top-options">
        <div className={cns(cn.filter, 'hidden-md', 'hidden-lg')}>
          <Button
            className={cns(cn.filterButton, {
              [cn.filledBtn]: hasActiveFilters,
            })}
            data-qa-selector="filter-button"
            onClick={onShowModalClick}
          >
            <FunnelIcon className={cn.filterIcon} />{' '}
            <span className={cn.filterButtonText}>
              {__('search.filterButton.title')}
            </span>
          </Button>
        </div>

        <div className={cn.rightControls}>
          <SortField
            name="sort"
            onChanged={onSortChanged}
            options={sortOptions}
            className={cn.sortField}
          />

          <Link
            className={cns('btn btn-icon hidden-md hidden-lg', {
              [cn.filledBtn]: hasFavorites,
            })}
            to={getFavoritesUrl()}
          >
            {hasFavorites ? (
              <span className={cn.favoritesCount}>{favoritesTotalCount}</span>
            ) : null}
            <FavoriteIcon isFilled={hasFavorites} className={cn.favoriteIcon} />
          </Link>
        </div>
      </div>
    );
  }
}

export default mapProps(propsMapping)(TopOptions);
